export default __webpack_public_path__ + "static/media/zx9.2fab6b4b.png";